import { Component, OnInit } from '@angular/core';
import { ImportPNREntryProprties, ImportRequest } from '../Models/ImportPnrProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { Observable, Subscription, of, timer, Subject } from 'rxjs';
import { UsersProperties, userBackCompanyCustomerCode } from '../Models/UsersProperties';
import { UsersService } from '../Services/users.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Bind } from 'primeng/bind';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-import-pnr-for-offline-issued',
    templateUrl: './import-pnr-for-offline-issued.component.html',
    styleUrls: ['./import-pnr-for-offline-issued.component.css'],
    imports: [NavMenuComponent, FormsModule, NgSelectModule, Bind, Select]
})
export class ImportPnrForOfflineIssuedComponent implements OnInit {

  constructor(private flightService: FlightSearchService, private router: Router, private messageService: MessageService, private userService: UsersService) { }

  importPNR = new ImportRequest();
  pccList: Supplier_OficeID[] = [];
  supplierId: string = "SPB_001";
  agencyID: string ="";
  GetAllUserBackCompanyCustomerCode: userBackCompanyCustomerCode[] = [];
  errorMessage: string = '';
  selectedCompany: userBackCompanyCustomerCode | null = null;
  ngOnInit() {
    this.flightService.GetGetAllBookingPCCs(this.supplierId)
      .subscribe(data => {
        this.pccList = data;
      });
    this.agencyID = localStorage.getItem("AgencyId");
    if (this.agencyID == "AG01") {
      this.userService.GetAllUserBackCompanyCustomerCode().subscribe((data) => {
        this.GetAllUserBackCompanyCustomerCode = data;
      });
    }
  }

  importButton() {
    //console.log(this.importPNR);
      var loader = document.getElementById("loaderissue") as HTMLDivElement;
      loader.classList.remove("loaders");
    try {
      if (this.selectedCompany === null) {
        // this.messageService.add({ severity: 'error', summary: 'CustomerCode Error', detail: "Please Select Customer Code First" });
        this.errorMessage = "Please Select Customer Code First";
        loader.classList.add("loaders");
        return;
      }

      localStorage.setItem("ImportForAgencyId", this.selectedCompany.agency_BranchId);
      localStorage.setItem("ImportForUserId", this.selectedCompany.userId.toString());
        this.importPNR.importAgency = String(localStorage.getItem("AgencyId"));
        this.importPNR.parentHierarchy = localStorage.getItem("ParentHierarchy");
        this.importPNR.importUser = Number(localStorage.getItem("UserId"));
      this.flightService.ImportPNRForIssuedOffline(this.importPNR, this.selectedCompany.userId, this.selectedCompany.agency_BranchId).subscribe((data) => {

          var loaders = document.getElementById("loaderissue") as HTMLDivElement;
          loaders.classList.add("loaders");
          if (data.isSaved) {
            var loaderf = document.getElementById("loaderissue") as HTMLDivElement;
            loaderf.classList.add("loaders");
            localStorage.setItem('importPNRID', JSON.stringify(data.bookingID));
            this.router.navigateByUrl('/create-invoice-from-pnr');
          }
          else {
            //this.messageService.add({ severity: 'error', summary: 'Try Again', detail: data.errorInfo });
            this.errorMessage = data.errorInfo;
            loader.classList.add("loaders");
          }

        });
      }



      catch (e) { }
    }

}
